import React from 'react';

import { useParams, useNavigate } from 'react-router-dom';

import { CoinRaceDetails } from '@entities/coin-race-details';

const CoinRaceDetailsPage = () => {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();

	React.useEffect(() => {
		if (!id) {
			navigate('/coin-race');
		}
	}, [id, navigate]);

	if (!id) {
		return null;
	}

	return <CoinRaceDetails id={id} />;
};

export default CoinRaceDetailsPage;

